<!-- (below 768 px the tab bar names the section) -->
<div class="section-divider d-none d-md-flex align-items-center gap-3 my-3">
  <div class="flex-grow-1 border-top"></div>
  <span class="fw-semibold small text-uppercase text-muted px-1" style="letter-spacing:.08em;">{{ 'STATISTIK_30_TAGE' | translate }}</span>
  <div class="flex-grow-1 border-top"></div>
</div>

<!-- ── Gesamtauswertung ── -->
<div *ngIf="stats.length > 0" class="mb-3">

  <!-- Jahres-Subtabs + Toggle (below 768 px: the year buttons share the row's free width, 36 px tall) -->
  <div class="stat-filter d-flex flex-wrap align-items-center gap-1 mb-2">
    <div class="stat-years d-flex gap-1">
      <button class="btn btn-sm" [ngClass]="globalYearFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setGlobalYear('all')">{{ 'GLOBAL_GESAMT' | translate }}</button>
      <button *ngFor="let y of globalStatYears" class="btn btn-sm" [ngClass]="globalYearFilter === y ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setGlobalYear(y)">{{ y }}</button>
    </div>
    <div class="position-relative ms-auto d-flex align-items-center gap-1 broken-data-wrap">
      <button class="btn btn-sm"
              [ngClass]="includeBrokenData ? 'btn-warning' : 'btn-outline-secondary'"
              (click)="toggleBrokenData()">
        ⚠ {{ 'STAT_BROKEN_DATA' | translate }}
      </button>
      <!-- Info button: mobile only (hover overlay shown on desktop via CSS) -->
      <button *ngIf="faultDays?.total! > 0" type="button" class="btn btn-sm btn-outline-secondary d-md-none stat-info-btn"
              (click)="openFaultInfo()" [title]="'FAULT_DAYS_LABEL' | translate"
              [attr.aria-label]="'FAULT_DAYS_LABEL' | translate">ⓘ</button>
      <div *ngIf="faultDays as fd" class="broken-data-overlay card shadow p-2">
        <!-- Summary (Inhalt der ehemaligen Fehltage-Card) -->
        <div class="d-flex align-items-center justify-content-between mb-1">
          <div style="font-size:.7rem;font-weight:600;text-transform:uppercase;"
               [class.text-warning]="fd.total > 0" [class.text-muted]="fd.total === 0">
            ⚠️ {{ 'FAULT_DAYS_LABEL' | translate }}
          </div>
          <div class="fw-bold ms-3" style="font-size:1rem;"
               [class.text-warning]="fd.total > 0" [class.text-muted]="fd.total === 0">
            {{ fd.total }} {{ 'AKKU_TAGE' | translate }}
          </div>
        </div>
        <ng-container *ngIf="fd.total === 0">
          <div class="text-muted" style="font-size:.75rem;">✓ {{ 'FAULT_DAYS_CLEAN' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="fd.total > 0">
          <div class="d-flex flex-wrap gap-1 mb-2" style="font-size:.72rem;">
            <span *ngIf="fd.wifi   > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.WIFI_OUTAGE' | translate">📶 {{ 'FAULT_TYPE_WIFI'   | translate }}: {{ fd.wifi }}</span>
            <span *ngIf="fd.freeze > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.DEYE_FREEZE' | translate">❄️ {{ 'FAULT_TYPE_FREEZE' | translate }}: {{ fd.freeze }}</span>
            <span *ngIf="fd.tigo   > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.TIGO_OUTAGE' | translate">☀️ {{ 'FAULT_TYPE_TIGO'   | translate }}: {{ fd.tigo }}</span>
            <span *ngIf="fd.noYield > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.NO_YIELD' | translate">🌑 {{ 'FAULT_TYPE_NO_YIELD' | translate }}: {{ fd.noYield }}</span>
            <span *ngIf="fd.data   > 0" class="badge bg-secondary"          [title]="'FAULT_REASON.DATA_MISSING' | translate">📊 {{ 'FAULT_TYPE_DATA'   | translate }}: {{ fd.data }}</span>
          </div>
          <!-- Detail-Liste -->
          <div *ngFor="let d of faultDayList" class="d-flex justify-content-between align-items-start gap-2 py-1 border-top border-secondary-subtle">
            <span class="text-muted" style="white-space:nowrap;">{{ fmtDay(d.date) }}</span>
            <span class="text-end">
              <span class="badge"
                    [ngClass]="{
                      'bg-danger':            d.faultReason === 'WIFI_OUTAGE',
                      'bg-warning text-dark': d.faultReason === 'TIGO_OUTAGE',
                      'bg-primary':           d.faultReason === 'DEYE_FREEZE',
                      'bg-secondary':         d.faultReason === 'NO_YIELD' || d.faultReason === 'DATA_MISSING'
                    }">{{ faultLabel(d.faultReason) }}</span>
              <span *ngIf="d.faultComment" class="text-muted ms-1" style="font-size:.68rem;">{{ d.faultComment }}</span>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="globalStats as g">

    <!-- Zeitraum + Datenbasis -->
    <div class="text-center text-muted mb-2" style="font-size:.7rem;">
      <ng-container *ngIf="globalYearFilter === 'all'">{{ 'GLOBAL_DATEN_SEIT' | translate:{date: fmtDay(g.since), days: g.days} }}</ng-container>
      <ng-container *ngIf="globalYearFilter !== 'all'">{{ globalYearFilter }} · {{ fmtDay(g.since) }} – {{ fmtDay(g.until) }} · {{ g.days }} {{ 'AKKU_TAGE' | translate }}</ng-container>
      <span *ngIf="!includeBrokenData && g.totalDays > g.validDays" class="ms-sm-2 text-warning stat-info-warn">
        <span class="d-none d-sm-inline">· </span>{{ 'STAT_VALID_DAYS' | translate:{valid: g.validDays, total: g.totalDays, faulty: g.totalDays - g.validDays} }}
      </span>
      <span *ngIf="includeBrokenData && g.totalDays > g.validDays" class="ms-sm-2 text-warning stat-info-warn">
        <span class="d-none d-sm-inline">· </span>{{ 'STAT_INCL_FAULTY' | translate:{n: g.totalDays - g.validDays} }}
      </span>
    </div>

    <!-- Zeile 1: Energie (phones: the lone 5th tile spans the width) -->
    <div class="row g-2 mb-2 m-fill-last">
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-warning">
          <div class="card-body p-2 text-center">
            <div class="text-warning" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">☀️ {{ 'GLOBAL_ERZEUGT' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.gen / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_GESAMT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-primary">
          <div class="card-body p-2 text-center">
            <div class="text-primary" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🏠 {{ 'GLOBAL_VERBRAUCHT' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.cons / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_GESAMT' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100"
             [class.border-success]="g.autarkie >= 80"
             [class.border-warning]="g.autarkie >= 50 && g.autarkie < 80"
             [class.border-danger]="g.autarkie < 50">
          <div class="card-body p-2 text-center">
            <div style="font-size:.7rem;font-weight:600;text-transform:uppercase;"
                 [class.text-success]="g.autarkie >= 80"
                 [class.text-warning]="g.autarkie >= 50 && g.autarkie < 80"
                 [class.text-danger]="g.autarkie < 50">⚡ {{ 'COLS.AUTARKIE' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;"
                 [class.text-success]="g.autarkie >= 80"
                 [class.text-warning]="g.autarkie >= 50 && g.autarkie < 80"
                 [class.text-danger]="g.autarkie < 50">{{ Math.floor(p(g.autarkie)) }}%</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_EIGENVERSORGUNG' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-danger">
          <div class="card-body p-2 text-center">
            <div class="text-danger" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🔌 {{ 'NETZBEZUG' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.imp / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_VOM_NETZ' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100 border-success">
          <div class="card-body p-2 text-center">
            <div class="text-success" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">🌿 {{ 'GLOBAL_CO2' | translate }}</div>
            <div class="fw-bold mt-1 text-success" style="font-size:1.3rem;">{{ p(g.co2Saved).toFixed(2) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_TONNEN_CO2' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Zeile 2: Finanzen -->
    <div class="row g-2 mb-2 m-fill-last">
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-info" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">💰 {{ 'GLOBAL_STROM_GESPART' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.savings).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">{{ ELECTRICITY_PRICE.toFixed(2) }} €/kWh</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-success" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">↑ {{ 'GLOBAL_EINSPEISUNG' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.feedinRevenue).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">{{ FEEDIN_TARIFF.toFixed(3) }} €/kWh · {{ p(g.exp / 1000).toFixed(1) }} MWh</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">📊 {{ 'GLOBAL_GESAMTNUTZEN' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.totalBenefit).toFixed(0) }} €</div>
            <div class="text-muted" style="font-size:.7rem;">≈ {{ p(g.annualBenefit).toFixed(0) }} €/{{ 'GLOBAL_JAHR' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">↑ {{ 'GLOBAL_EINGESPEIST' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.exp / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_INS_NETZ' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-lg">
        <div class="card h-100">
          <div class="card-body p-2 text-center">
            <div class="text-muted" style="font-size:.7rem;font-weight:600;text-transform:uppercase;">⚡ {{ 'GLOBAL_EIGENVERBRAUCH' | translate }}</div>
            <div class="fw-bold mt-1" style="font-size:1.3rem;">{{ p(g.selfConsumed / 1000).toFixed(1) }}</div>
            <div class="text-muted" style="font-size:.7rem;">{{ 'GLOBAL_MWH_SELBST' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Amortisation (nur All-Time) -->
    <div *ngIf="globalYearFilter === 'all'" class="card mb-2">
      <div class="card-body p-2 p-sm-3">
        <div class="d-flex justify-content-between align-items-start mb-2">
          <div class="text-muted" style="font-size:.75rem;font-weight:600;text-transform:uppercase;">🏗️ {{ 'GLOBAL_AMORTISATION' | translate }}</div>
          <div class="text-end">
            <span class="fw-bold">{{ (g.amortisation ?? 0).toFixed(1) }}%</span>
            <span class="text-muted small ms-1">{{ 'GLOBAL_VON' | translate:{eur: systemCost} }}</span>
          </div>
        </div>
        <div class="progress" style="height:12px;border-radius:6px;">
          <div class="progress-bar"
               [class.bg-danger]="(g.amortisation ?? 0) < 30"
               [class.bg-warning]="(g.amortisation ?? 0) >= 30 && (g.amortisation ?? 0) < 70"
               [class.bg-success]="(g.amortisation ?? 0) >= 70"
               role="progressbar"
               [style.width.%]="(g.amortisation ?? 0) > 100 ? 100 : (g.amortisation ?? 0)">
          </div>
        </div>
        <div class="d-flex justify-content-between mt-1">
          <span class="text-muted" style="font-size:.7rem;">{{ p(g.totalBenefit).toFixed(0) }} € {{ 'GLOBAL_VON' | translate:{eur: systemCost} }}</span>
          <span *ngIf="g.paybackYears !== null" class="text-muted" style="font-size:.7rem;">
            ≈ {{ g.paybackYears.toFixed(1) }} {{ 'GLOBAL_JAHRE_BREAK_EVEN' | translate }}
          </span>
        </div>
      </div>
    </div>

    <!-- Annahmen -->
    <div class="text-muted text-center mt-1 mb-2 dash-meta">
      {{ 'GLOBAL_ANNAHMEN' | translate:{preis: ELECTRICITY_PRICE.toFixed(2), tarif: FEEDIN_TARIFF.toFixed(3), co2: CO2_FACTOR.toFixed(3)} }}
    </div>

  </div>
</div>

<!-- ── Verlauf ── -->
<div *ngIf="stats.length > 0">
  <div class="section-divider d-flex align-items-center gap-3 mb-2">
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    <span class="small text-muted px-1">{{ 'GLOBAL_VERLAUF' | translate }}</span>
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
  </div>
  <!-- Month filter: chips from 768 px; below, a select (20+ chips would fill a phone screen) beside the
       daily / monthly switch -->
  <div class="stat-ctrl">
    <div *ngIf="statsView === 'daily'" class="d-none d-md-flex flex-wrap gap-1">
      <button class="btn btn-sm" [ngClass]="statsMonthFilter === 'all' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setStatsMonth('all')">{{ 'ALLE' | translate }}</button>
      <button *ngFor="let m of statsMonths" class="btn btn-sm" [ngClass]="statsMonthFilter === m ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setStatsMonth(m)">{{ fmtMonth(m) }}</button>
    </div>
    <select *ngIf="statsView === 'daily'" class="form-select form-select-sm d-md-none"
            [attr.aria-label]="'COLS.MONAT' | translate"
            (change)="setStatsMonth($any($event.target).value)">
      <option value="all" [selected]="statsMonthFilter === 'all'">{{ 'STAT_ALLE_MONATE' | translate }}</option>
      <option *ngFor="let m of statsMonths" [value]="m" [selected]="statsMonthFilter === m">{{ fmtMonthYear(m) }}</option>
    </select>
    <div class="ms-auto btn-group btn-group-sm dash-seg" role="group">
      <button class="btn" [ngClass]="statsView === 'daily' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setStatsView('daily')">{{ 'GLOBAL_TAEGLICH' | translate }}</button>
      <button class="btn" [ngClass]="statsView === 'monthly' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setStatsView('monthly')">{{ 'GLOBAL_MONATLICH' | translate }}</button>
    </div>
  </div>
  <!-- compact grid: the symbol headers explained -->
  <div *ngIf="compact" class="dash-meta text-muted mb-1">
    kWh: {{ 'COLS.ERTRAG' | translate }} · {{ 'COLS.VERBRAUCH' | translate }} · {{ 'COLS.BEZUG' | translate }} · {{ 'COLS.EINSPEISUNG' | translate }} · %: {{ 'COLS.AUTARKIE' | translate }}
  </div>
  <!-- From 768 px a fixed-height grid that scrolls inside; below, the grid grows with the page (no nested
       scrolling) and shows statsRowLimit rows (sorted first) — "show more" adds a month (a year of months) -->
  <ag-grid-angular
    *ngIf="statsView === 'daily'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [class.stat-grid-compact]="compact"
    [style.height.px]="compact ? null : statsGridHeight(filteredStats.length)"
    [domLayout]="compact ? 'autoHeight' : 'normal'"
    [pagination]="compact"
    [paginationPageSize]="statsRowLimit"
    [paginationPageSizeSelector]="false"
    [suppressPaginationPanel]="true"
    [rowHeight]="compact ? 36 : 32"
    [rowData]="filteredStats"
    [columnDefs]="statsColDefs"
    [gridOptions]="statsGridOptions">
  </ag-grid-angular>
  <ag-grid-angular
    *ngIf="statsView === 'monthly'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [class.stat-grid-compact]="compact"
    [style.height.px]="compact ? null : statsGridHeight(monthlyStats.length)"
    [domLayout]="compact ? 'autoHeight' : 'normal'"
    [pagination]="compact"
    [paginationPageSize]="statsRowLimit"
    [paginationPageSizeSelector]="false"
    [suppressPaginationPanel]="true"
    [rowHeight]="compact ? 36 : 32"
    [rowData]="monthlyStats"
    [columnDefs]="monthlyStatsColDefs"
    [gridOptions]="monthlyGridOptions">
  </ag-grid-angular>
  <ng-container *ngIf="compact && (statsView === 'daily' ? filteredStats.length : monthlyStats.length) as rows">
    <button *ngIf="rows > statsRowLimit" type="button" class="btn btn-sm btn-outline-secondary w-100 mt-2 stat-more"
            (click)="showMoreStats()">
      {{ ('STAT_MEHR' | translate) + ' · ' }}<span class="opacity-75">{{ statsRowLimit }} / {{ rows }}</span>
    </button>
  </ng-container>
</div>
<div *ngIf="stats.length === 0 && loading" class="mb-3">
  <div class="row g-2 mb-2 m-fill-last">
    <div class="col-6 col-sm-4 col-lg" *ngFor="let _ of [0,1,2,3,4]">
      <div class="card h-100">
        <div class="card-body p-2 text-center">
          <app-skeleton width="70%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 8px;"></app-skeleton>
          <app-skeleton width="50%" height="1.5rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 6px;"></app-skeleton>
          <app-skeleton width="60%" height=".65rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-2 m-fill-last">
    <div class="col-6 col-sm-4 col-lg" *ngFor="let _ of [0,1,2,3,4]">
      <div class="card h-100">
        <div class="card-body p-2 text-center">
          <app-skeleton width="70%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 8px;"></app-skeleton>
          <app-skeleton width="50%" height="1.5rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto 6px;"></app-skeleton>
          <app-skeleton width="60%" height=".65rem" radius="4px" [darkMode]="darkMode" style="display:block;margin:0 auto;"></app-skeleton>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="stats.length === 0 && !loading" class="text-muted small text-center py-2">{{ 'KEINE_DATEN' | translate }}</div>

<!-- ── Pellet-Statistik ── -->
<div *ngIf="pelletStats.length > 0" class="mt-3">
  <div class="section-divider d-flex align-items-center gap-3 mb-2">
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
    <span class="small text-muted px-1">🪵 {{ 'HEIZUNG_PELLET_STATISTIK' | translate }}</span>
    <div class="flex-grow-1 border-top" style="border-color:var(--bs-border-color-translucent)!important;"></div>
  </div>

  <div class="stat-ctrl">
    <div class="text-muted text-nowrap" style="font-size:.75rem;">
      {{ 'HEIZUNG_PELLET_GESAMT' | translate }}: <span class="fw-bold">{{ pelletTotalKg() | number:'1.0-0' }} kg</span>
    </div>
    <div class="ms-auto btn-group btn-group-sm dash-seg" role="group">
      <button class="btn" [ngClass]="pelletStatsView === 'daily' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setPelletStatsView('daily')">{{ 'GLOBAL_TAEGLICH' | translate }}</button>
      <button class="btn" [ngClass]="pelletStatsView === 'monthly' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="setPelletStatsView('monthly')">{{ 'GLOBAL_MONATLICH' | translate }}</button>
    </div>
  </div>
  <!-- compact grid: the unit headers explained -->
  <div *ngIf="compact" class="dash-meta text-muted mb-1">
    kg: {{ 'HEIZUNG_PELLET_VERBRAUCH' | translate }} · h: {{ 'HEIZUNG_PELLET_BRENNDAUER' | translate }} · kg/h: Ø {{ 'HEIZUNG_PELLET_BEIM_BRENNEN' | translate }}<ng-container *ngIf="pelletStatsView === 'daily'"> · %: {{ 'HEIZUNG_PELLET_BEHAELTER' | translate }}</ng-container>
  </div>

  <!-- as the energy grids: below 768 px the grid grows with the page, pelletRowLimit rows + "show more" -->
  <ag-grid-angular
    *ngIf="pelletStatsView === 'daily'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [class.stat-grid-compact]="compact"
    [style.height.px]="compact ? null : pelletGridHeight(pelletStats.length)"
    [domLayout]="compact ? 'autoHeight' : 'normal'"
    [pagination]="compact"
    [paginationPageSize]="pelletRowLimit"
    [paginationPageSizeSelector]="false"
    [suppressPaginationPanel]="true"
    [rowData]="pelletStats"
    [columnDefs]="pelletColDefs"
    [gridOptions]="pelletGridOptions">
  </ag-grid-angular>
  <ag-grid-angular
    *ngIf="pelletStatsView === 'monthly'"
    [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
    [class.stat-grid-compact]="compact"
    [style.height.px]="compact ? null : pelletGridHeight(pelletMonthlyStats.length)"
    [domLayout]="compact ? 'autoHeight' : 'normal'"
    [pagination]="compact"
    [paginationPageSize]="pelletRowLimit"
    [paginationPageSizeSelector]="false"
    [suppressPaginationPanel]="true"
    [rowData]="pelletMonthlyStats"
    [columnDefs]="pelletMonthlyColDefs"
    [gridOptions]="pelletGridOptions">
  </ag-grid-angular>
  <ng-container *ngIf="compact && (pelletStatsView === 'daily' ? pelletStats.length : pelletMonthlyStats.length) as rows">
    <button *ngIf="rows > pelletRowLimit" type="button" class="btn btn-sm btn-outline-secondary w-100 mt-2 stat-more"
            (click)="showMorePellets()">
      {{ ('STAT_MEHR' | translate) + ' · ' }}<span class="opacity-75">{{ pelletRowLimit }} / {{ rows }}</span>
    </button>
  </ng-container>
</div>

<!-- ── Fault days sheet (ⓘ below 768 px; view 'statistik/faults') — a full-screen sheet on phones ── -->
<ng-container *ngIf="faultInfoOpen && stats.length > 0">
  <div *ngIf="faultDays as fd" class="dash-overlay" style="background:rgba(0,0,0,.5);" (click)="closeFaultInfo()">
    <div class="dash-sheet bg-body shadow-lg" style="width:min(92vw,520px);max-height:85vh;"
         role="dialog" aria-modal="true" [attr.aria-label]="'FAULT_DAYS_LABEL' | translate"
         (click)="$event.stopPropagation()">
      <div class="dash-sheet-head">
        <span class="dash-sheet-title">⚠️ {{ 'FAULT_DAYS_LABEL' | translate }}</span>
        <app-link-button></app-link-button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeFaultInfo()"
                [attr.aria-label]="'CLOSE' | translate">✕</button>
      </div>
      <div class="dash-sheet-body">
        <div class="fw-bold mb-2" style="font-size:1.1rem;"
             [class.text-warning]="fd.total > 0" [class.text-muted]="fd.total === 0">
          {{ fd.total }} {{ 'AKKU_TAGE' | translate }}
        </div>
        <ng-container *ngIf="fd.total === 0">
          <div class="text-muted small">✓ {{ 'FAULT_DAYS_CLEAN' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="fd.total > 0">
          <div class="d-flex flex-wrap gap-1 mb-3" style="font-size:.9375rem;">
            <span *ngIf="fd.wifi   > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.WIFI_OUTAGE' | translate">📶 {{ 'FAULT_TYPE_WIFI'   | translate }}: {{ fd.wifi }}</span>
            <span *ngIf="fd.freeze > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.DEYE_FREEZE' | translate">❄️ {{ 'FAULT_TYPE_FREEZE' | translate }}: {{ fd.freeze }}</span>
            <span *ngIf="fd.tigo   > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.TIGO_OUTAGE' | translate">☀️ {{ 'FAULT_TYPE_TIGO'   | translate }}: {{ fd.tigo }}</span>
            <span *ngIf="fd.noYield > 0" class="badge bg-warning text-dark" [title]="'FAULT_REASON.NO_YIELD' | translate">🌑 {{ 'FAULT_TYPE_NO_YIELD' | translate }}: {{ fd.noYield }}</span>
            <span *ngIf="fd.data   > 0" class="badge bg-secondary" [title]="'FAULT_REASON.DATA_MISSING' | translate">📊 {{ 'FAULT_TYPE_DATA'   | translate }}: {{ fd.data }}</span>
          </div>
          <!-- a day per row: date + reason, the note below (wraps) -->
          <div *ngFor="let d of faultDayList" class="stat-fault-row">
            <div class="d-flex justify-content-between align-items-center gap-2">
              <span class="small fw-semibold text-nowrap">{{ fmtDay(d.date) }}</span>
              <span class="badge"
                    [ngClass]="{
                      'bg-danger':            d.faultReason === 'WIFI_OUTAGE',
                      'bg-warning text-dark': d.faultReason === 'TIGO_OUTAGE',
                      'bg-primary':           d.faultReason === 'DEYE_FREEZE',
                      'bg-secondary':         d.faultReason === 'NO_YIELD' || d.faultReason === 'DATA_MISSING'
                    }">{{ faultLabel(d.faultReason) }}</span>
            </div>
            <div *ngIf="d.faultComment" class="dash-meta text-muted mt-1">{{ d.faultComment }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<!-- ── Hourly chart overlay (view 'statistik/<date>') — a full-screen sheet on phones, the chart fills it ── -->
<div *ngIf="hourlyDate" class="dash-overlay" style="background:rgba(0,0,0,.55);" (click)="closeHourly()">
  <div class="dash-sheet bg-body shadow-lg" style="width:min(96vw,900px);max-height:92vh;"
       role="dialog" aria-modal="true" [attr.aria-label]="hourlyTitle"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="dash-sheet-head">
      <span class="dash-sheet-title">📊 {{ hourlyTitle }}<span *ngIf="hourlyField" class="text-muted fw-normal"> · {{ hourlyFieldLabel(hourlyField) }}</span></span>
      <app-link-button></app-link-button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeHourly()"
              [attr.aria-label]="'CLOSE' | translate">✕</button>
    </div>

    <!-- Body -->
    <div class="dash-sheet-body dash-sheet-fill">

      <!-- The day's sunrise / sunset and fault reason (the compact grid has no columns for them) -->
      <div *ngIf="hourlyDay as d" class="dash-meta text-muted mb-2">
        <span *ngIf="d.sunriseUtc">🌅 {{ d.sunriseUtc }} · 🌇 {{ d.sunsetUtc }} UTC</span>
        <div *ngIf="d.faultReason" class="text-warning">⚠ {{ 'FAULT_REASON.' + d.faultReason | translate }}<ng-container *ngIf="d.faultComment"> – {{ d.faultComment }}</ng-container></div>
      </div>

      <!-- Loading -->
      <div *ngIf="hourlyLoading" class="d-flex align-items-center justify-content-center" style="min-height:200px;">
        <div class="spinner-border text-secondary" role="status"></div>
      </div>

      <!-- Error -->
      <div *ngIf="hourlyError && !hourlyLoading" class="text-center text-muted py-5 small">
        ⚠ {{ 'STAT_HOURLY_ERROR' | translate }}
      </div>

      <!-- Empty -->
      <div *ngIf="!hourlyLoading && !hourlyError && hourlyData.length === 0" class="text-center text-muted py-5 small">
        {{ 'KEINE_DATEN' | translate }}
      </div>

      <!-- Chart -->
      <app-hourly-chart
        *ngIf="!hourlyLoading && !hourlyError && hourlyData.length > 0"
        class="dash-sheet-fill-item"
        [data]="hourlyData"
        [field]="hourlyField"
        [darkMode]="darkMode"
        [linkId]="hourlyLinkId">
      </app-hourly-chart>

    </div>
  </div>
</div>
